import { getApiUrl } from '../utils/environment';

export const LANG_URL =
  'https://language-resources.kry.se/language/GB/language_booking_tool.json';

export const BOOKING_SLOTS_URL = `https://${getApiUrl()}/api/uk-partnership/partnership-booking-management/slots`;

export const BOOK_MEETING_URL = `https://${getApiUrl()}/api/uk-partnership/partnership-booking-management/meeting/book`;

export const BOOKED_APPOINTMENTS_URL = `https://${getApiUrl()}/api/uk-partnership/partnership-booking-management/bookings`;

export const PRACTICE_SETTINGS_URL = `https://${getApiUrl()}/api/uk-partnership/partnership-booking-management/practice/settings`;

export const LOGOUT_URL = `https://${getApiUrl()}/api/uk-partnership/partnership-booking-management/logout`;
